import { useQuery } from '@tanstack/react-query';
import { GetUsersParams, usersService } from '../../../services';

export function useUsers(params: GetUsersParams = {}) {
  return useQuery({
    queryKey: ['users', params],
    queryFn: async () => {
      const response = await usersService.getUsers(params);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar usuários');
      }

      return response.data;
    },
    staleTime: 0, // Sempre busca dados frescos ao acessar a lista de usuários
  });
}
